import React, { useEffect, useRef } from "react";

export default function AudioTrack({ track }) {
  const ref = useRef();

  useEffect(() => {
    if (track) {
      const el = ref.current;
      track.track.attach(el);

      return () => {
        track.track.detach(el);
      };
    }
  }, [track]);

  return <audio ref={ref} />;
}
